import useStore, { getApplicationChannelFromState } from "../../store";

const useApplicationChannel = () => useStore(getApplicationChannelFromState);

export default useApplicationChannel;
